(() => {
  const progress = document.querySelector('[data-lvps-progress]');
  const sticky = document.querySelector('[data-lvps-sticky]');
  const close = document.querySelector('[data-lvps-sticky-close]');
  let dismissed = false;
  const update = () => {
    const max = document.documentElement.scrollHeight - window.innerHeight;
    const ratio = max > 0 ? Math.min(1, Math.max(0, window.scrollY / max)) : 0;
    if (progress) progress.style.width = `${ratio * 100}%`;
    if (sticky && !dismissed) sticky.classList.toggle('is-visible', ratio >= 0.5 && ratio < 0.94);
  };
  close?.addEventListener('click', () => {
    dismissed = true;
    sticky?.classList.remove('is-visible');
    sticky?.setAttribute('hidden', '');
  });
  document.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update, { passive: true });
  update();
})();
